import type { QueryClient } from '@tanstack/react-query';
import { authApi } from '@/api/endpoints/auth';
import { resetAnalytics } from '@/lib/analytics';
import { clearSupportSessionTab } from './session';
import { endSession } from './sessionService';

/**
 * Logout (parity §0): call the API ignoring errors, clear the session hint,
 * forget the person in analytics, clear the support-tab marker, drop every
 * cached query (no data survives into the next person's session), then go
 * to /login.
 */
export const logout = async (queryClient: QueryClient, navigateToLogin: () => void | Promise<void>): Promise<void> => {
  try {
    await authApi.logout();
  } catch {
    // Continue: a failed logout call must not leave the user signed in locally.
  } finally {
    endSession();
    // Before the support marker goes, so a client loaded to reset captures nothing.
    await resetAnalytics();
    clearSupportSessionTab();
    queryClient.cancelQueries().catch(() => undefined);
    queryClient.clear();
    await navigateToLogin();
  }
};
